export const APP_CONSTANTS = {
  APURIMAC_ID: 'kacwggmapu7qs',
  PACKAGE_ID_FREE: '80868fff-39dd-4184-baa6-43dbe6223098',
  DEFAULT_IMAGE_PROFILE: 'assets/img/user.png',
  DEFAULT_IMAGE_COMPANY: 'assets/icon/company.jpg',
  DEFAULT_BANNER_COMPANY: 'assets/img/banner.jpg',
  DEFAULT_TEAM_COMPANY: 'assets/icon/team.jpg',
  DEFAULT_IMAGE_PROFILE_POSTULANT: 'assets/img/user2.png',
  DEFAULT_ICON_SOLES: 'assets/icon/soles.png',
  TOP_JOBS_NUMBER: 3,
};

export const AUTH_STORAGE_KEY = 'CodijobsAuth';
